import styled from 'styled-components'
import Image from 'common/image'
import WinIcon from 'assets/wins_icon.png'
import { useTranslation } from 'react-i18next'

const BoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 359px;
    padding: 32px 20px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
`

const TitleUnderLine = styled.div`
    width: 59px;
    height: 5px;
    background: #d9c277;
`

const FirstLineRow = styled.div`
    padding-top: 32px;
    display: flex;
    flex-direction: row;
`

const FirstLineText = styled.div`
    color: #4e3821;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 125% */
`

const SecondLineText = styled.div`
    padding-top: 16px;
    color: #4e3821;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 125% */
`

export default function WhatIsWins() {
    const { t } = useTranslation('', { keyPrefix: 'earnwins.whatiswins' })

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t('leftLabel')}</TitleText>
                <Image
                    src={WinIcon}
                    width={21}
                    height={21}
                    alt="wins icon"
                    style={{
                        marginLeft: '6px',
                        marginRight: '2px',
                    }}
                />
                <TitleText>{t('rightLabel')}</TitleText>
            </TitleContainer>
            <TitleUnderLine />
            <Image
                src={t('whatiswinsImage')}
                width={318}
                height={193}
                style={{ borderRadius: '25px', marginTop: '32px' }}
                alt="earns wins promotion banner"
            />
            <FirstLineRow>
                <FirstLineText>{t('firstParagraph')}</FirstLineText>
            </FirstLineRow>
            <SecondLineText>{t('secondParagraph')}</SecondLineText>
        </BoxContainer>
    )
}
